// Angular Material's MatRippleLoader and Angular CDK's FocusMonitor each register a single
// shared, document-level, capture-phase 'focus' listener the first time any ripple/focus-
// monitored element (basically any mat-*-button) mounts. That listener walks the full DOM
// ancestor chain of whichever element receives focus and triggers an Angular change-detection
// cycle for every focus-monitored ancestor it finds along the way. On pages with many
// components mounted at once (e.g. a long list of prediction cards), that synchronous work is
// slow enough to disrupt the browser's native click-event synthesis on Chrome/Firefox (desktop
// and Android): mousedown and mouseup fire normally, but no click event ever follows, so taps on
// buttons silently do nothing. WebKit (Safari/iOS) isn't affected, which is why the bug only
// showed up on some platforms. Confirmed live in the browser: removing this exact listener
// (after the fact, via devtools) immediately restores normal clicks — but Angular Material
// re-registers it (with its own internal reference counting) as soon as another such element
// mounts, so removing it after the fact from application code doesn't stick. Blocking the
// registration at the source, before zone.js even loads, avoids fighting that reference count.
// This file must load before "zone.js" — see the "polyfills" array in angular.json.
// This only touches this one specific (event, capture) pair on `document` — everything else
// keeps going through the real addEventListener untouched.
(function blockSlowGlobalFocusListener() {
  const nativeAddEventListener = Document.prototype.addEventListener;
  Document.prototype.addEventListener = function (
    this: Document,
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
  ): void {
    const capture = typeof options === 'boolean' ? options : !!(options && options.capture);
    if (type === 'focus' && capture) {
      return;
    }
    return nativeAddEventListener.call(this, type, listener as EventListenerOrEventListenerObject, options);
  };
})();
